import React from 'react';
const rows = [['Opening the toolbag before you know the cycle', 'The Split answered in the first 15 minutes'], ['Replacing a valve that only needed cleaning', 'Bad valve vs dirty screen in 2 minutes'], ['Resetting the code and leaving', 'Find the cause, so the code stays gone'], ['Callbacks on the same machine', 'The Repeat-Call Trap List on every job'], ['Writing reports and logs after hours', '38 forms ready to fill on site']];
export function CostOfInaction() {
  return <section className="w-full bg-pine" data-id="element-63" data-mp="38x3gu4ur2ant">
      <div className="mx-auto max-w-3xl px-5 py-14 sm:py-20" data-id="element-64" data-mp="38w26y3pgzu7o">
        <h2 className="text-center font-display text-[32px] uppercase leading-tight text-paper sm:text-5xl" data-id="element-65" data-mp="3do209db1bova">
          What another season of swapping parts costs you
        </h2>
        <div className="mt-8 overflow-hidden rounded-2xl border border-paper/15" data-id="element-66" data-mp="3nmrjpaikxhdn">
          <div className="grid grid-cols-2 text-center" data-id="element-67" data-mp="3nkol423d2fxb">
            <div className="border-r border-paper/15 bg-signal px-3 py-3 font-display text-lg uppercase text-white sm:text-xl" data-id="element-68" data-mp="3smdznrpslbq5">
              Swapping parts
            </div>
            <div className="bg-forest px-3 py-3 font-display text-lg uppercase text-white sm:text-xl" data-id="element-69" data-mp="39h3ots4battm">
              Ice Machine Diagnostic Pro
            </div>
          </div>
          {rows.map(([bad, good]) => <div key={bad} className="grid grid-cols-2 border-t border-paper/15 text-[13px] leading-snug sm:text-sm" data-id="element-70" data-mp="30i05cn18gcel">
              <div className="border-r border-paper/15 px-3.5 py-3.5 text-paper/60 line-through decoration-signal/60" data-id="element-71" data-mp="3s84lg9hymda0">
                {bad}
              </div>
              <div className="px-3.5 py-3.5 font-semibold text-paper" data-id="element-72" data-mp="3nfbi9q253d01">{good}</div>
            </div>)}
        </div>
      </div>
    </section>;
}